import * as actionTypes from './actionTypes';
const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PLAN_TYPE:
      return { ...state, planType: action.payload };
    case actionTypes.SET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.SET_REBATE_LIST:
      return { ...state, rebate_list: action.payload };
    case actionTypes.SET_TASK_TYPE:
      return { ...state, taskType: action.payload };
    case actionTypes.SET_REMINDER_SETUP_LIST:
      return { ...state, reminder_list: action.reminderSetupList };
    case actionTypes.GET_ALL_TEMPLATE_TYPE:
      return { ...state, TemplateType: action.TemplateType };
    case actionTypes.INPUT_FIELD_VALUE_ACTION:
      return { ...state, getInputValue: action.payloadInputVal };
    case actionTypes.GET_CHECKLOG_ERROR_MSG:
      return { ...state, errorMsgCheckLog: action.payload };
    case actionTypes.GET_CHECKSUSP_ERROR_MSG:
      return { ...state, errorMsgCheckSusp: action.payload };
    case actionTypes.GET_COLLECT_ERROR_MSG:
      return { ...state, errorMsgCollect: action.payload };
    case actionTypes.GET_MAILED_DATE_ERROR_MSG:
      return { ...state, errorMsgMailedDate: action.payload };
    case actionTypes.SAVE_OR_UPDATE_RR:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };
    case actionTypes.DELETE_REMINDER:
      return { ...state, getDeleteReminder: action.getDeleteReminder };
    default:
      return { ...state };
  }
};

export default reducer;
